module.exports = __webpack_public_path__ + "static/media/icons8-refresh.36083e02.svg";